module.exports = window["MaterialUI"].Avatar;